import './NotFound.scss';

const NotFound = () => {
	return <div className='not_found_container'></div>;
};

export default NotFound;
